import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-radio-widget',
  templateUrl: './sf-radio-widget.component.html'
})
export class RadioWidgetComponent extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/radio/sf-radio-widget.component.ts